import * as React from 'react'

import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Link,
  Typography,
} from '@mui/material'

import Ribbon from '~/components/Custom/Ribbon'
import L from '~/components/Helpers/Lang'
import { routeNames } from '~/constants/uiRouteNames'

const DashboardProductListItem = ({ product }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Card sx={{ height: '100%' }}>
      <CardActionArea
        component={Link}
        to={`${routeNames.root}${routeNames.products}/${
          product.slugs?.[0] ?? product.id
        }`}
        sx={{ height: '100%' }}
      >
        {Boolean(product.hidden) && (
          <Ribbon color="warning" label={<L term="ribbon.hidden" />} />
        )}
        {Boolean(product.coming_soon) && (
          <Ribbon color="info" label={<L term="ribbon.coming_soon" />} />
        )}
        {Boolean(product.show_as_new) && (
          <Ribbon color="success" label={<L term="ribbon.new" />} />
        )}
        <CardMedia
          sx={{ height: 240 }}
          image={`${product?.images?.[0]?.url}/${product?.images?.[0]?.file_name}`}
          title={product?.texts?.product_name}
        />
        <CardContent>
          <Typography
            gutterBottom
            color="primary"
            variant="h5"
            sx={{ fontWeight: 300 }}
          >
            {product?.texts?.product_name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ pr: 10 }}>
            {product?.texts?.product_tagline}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  </Grid>
)

export default DashboardProductListItem
